import axiosInstance from '../axiosInstance';

const createTicket = async ({ type, message }) => {
  return axiosInstance.post('/ticket', { type, message }).then((response) => {
    return response.data;
  });
};

const getMyTickets = async () => {
  return axiosInstance.get('/ticket/mine').then((response) => {
    return response.data;
  });
};

const getAllTickets = async () => {
  return axiosInstance.get('/ticket/all').then((response) => {
    return response.data;
  });
};

const getTicket = async (id) => {
  return axiosInstance.get(`/ticket/${id}`).then((response) => {
    return response.data;
  });
};

// Resolving emails the ticket's owner a resolution note.
const resolveTicket = async (id, resolutionNote) => {
  return axiosInstance.put(`/ticket/${id}/resolve`, { resolutionNote }).then((response) => {
    return response.data;
  });
};

const ticketService = {
  createTicket,
  getMyTickets,
  getAllTickets,
  getTicket,
  resolveTicket
};

export default ticketService;
